<template>
  <div :class="classes">
      <pt-page-title title="创建重采订单"></pt-page-title>
      <div v-loading="loading" >
      <sample-order-message :orderDetail="orderDetail"></sample-order-message>
      <sample-form-message :mallOrderId="orderDetail.id" :sampleId="sampleId" :shippingAddress="shippingAddress"
      :recollectPrice="recollectPrice" :placementDetails="placementDetails" :sampleType="sampleType"></sample-form-message>
      </div>
  </div>
</template>

<script>
// 组件class前缀
import sampleOrderMessage from './sample-order-message'
import sampleFormMessage from './sample-form-message'
const prefixCls = 'pt-sample-recollect-detail'
export default {
  name: 'pt-sample-recollect-detail',
  computed: {
    classes () {
      return `${prefixCls}`
    },
    shippingAddress () {
      return (this.orderDetail && this.orderDetail.shippingAddress) || {}
    },
    placementDetails () {
      return (this.orderDetail && this.orderDetail.placementDetails) || {}
    }
  },
  components: {
    sampleOrderMessage,
    sampleFormMessage
  },
  props: {
    sampleId: {
      type: String,
      default: ''
    },
    orderDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    recollectPrice: {
      type: Number,
      default: 0
    },
    loading: {
      type: Boolean,
      default: false
    },
    sampleType: {
      type: String,
      default: null
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */

</style>
